<template>
  <div>
    <img
      src="data:image/png;base64,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"
      class="silde-left"
    />
    <img
      src="data:image/png;base64,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"
      class="silde-right"
    />

    <!-- <div class="top-bar">
      <div class="top-bar-f">Works with Minder, Minder Works</div>
    </div> -->

    <Header
      id="heard1"
      style="z-index: 99; top: 0; background-color: #fff"
    ></Header>

    <div class="fastStart">
      <div class="fastCon">
        <div class="fast-top">
          <img v-if="$i18n.locale === 'zh-CN'" src="./image/1946.png" />
          <img v-if="$i18n.locale === 'en-US'" src="./image/1946-US.png" />
        </div>
        <div class="fast-con">
          <div>
            <div class="fastCon-title">
              <img src="./image/STEP1.png" />
            </div>
            <div class="fastCon-Con">
              <div class="itemTitle">{{ data.setp1.title }}</div>
              <p v-for="item in data.setp1.list" :key="item">
                {{ item }}
              </p>
              <div class="itemImg">
                <img v-if="$i18n.locale === 'zh-CN'" src="./image/1950.png" />
                <img v-if="$i18n.locale === 'en-US'" src="./image/2695.png" />
              </div>
              <div v-if="$i18n.locale === 'en-US'" class="step1-US">
                <div>
                  <img src="./image/5.png" />
                  <div>
                    <p>1. Input your email address on the page.</p>
                    <p>
                      2. Please click the button “Get Verified“. A code will be
                      sent to your email box and you need to check and input the
                      code from your email box
                    </p>
                    <p>3. Please set a new password below.</p>
                    <p>4. Click the “Log in” button.</p>
                    <p>
                      5. Then use the email and new password to login the
                      system.
                    </p>
                  </div>
                </div>
                <div>
                  <img src="./image/2695-2.png" />
                  <div>
                    <p>1. Input your email which you just verified.</p>
                    <p>2. Input your new password.</p>
                    <p>3. Click “Log in” to enter our service.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="fastCon-title">
              <img src="./image/STEP2.png" />
            </div>
            <div class="fastCon-Con">
              <div class="itemTitle">{{ data.setp2.title }}</div>
              <p v-for="item in data.setp2.list" :key="item">
                {{ item }}
              </p>
              <div class="itemImg">
                <img v-if="$i18n.locale === 'zh-CN'" src="./image/1958.png" />
                <img v-if="$i18n.locale === 'en-US'" src="./image/2695-5.png" />
              </div>
            </div>
          </div>
          <div>
            <div class="fastCon-title">
              <img src="./image/STEP3.png" />
            </div>
            <div class="fastCon-Con">
              <div class="itemTitle">{{ data.setp3.title }}</div>
              <p v-for="item in data.setp3.list" :key="item">
                {{ item }}
              </p>
              <div v-if="$i18n.locale === 'zh-CN'" class="itemImg">
                <img src="./image/1958-3.png" />
                <img src="./image/1958-4.png" />
              </div>
              <div v-if="$i18n.locale === 'en-US'" class="itemImg">
                <img src="./image/2695-4.png" />
              </div>
            </div>
          </div>
          <div>
            <div class="fastCon-title">
              <img src="./image/STEP4.png" />
            </div>
            <div class="fastCon-Con">
              <div class="itemTitle">{{ data.setp4.title }}</div>
              <p v-for="item in data.setp4.list" :key="item">
                {{ item }}
              </p>
              <div class="itemImg">
                <img v-if="$i18n.locale === 'zh-CN'" src="./image/1958-5.png" />
                <img v-if="$i18n.locale === 'en-US'" src="./image/2695-6.png" />
              </div>
            </div>
          </div>
          <div>
            <div class="fastCon-title">
              <img src="./image/STEP5.png" />
            </div>
            <div class="fastCon-Con">
              <div class="itemTitle">{{ data.setp5.title }}</div>
              <p v-for="item in data.setp5.list" :key="item">
                {{ item }}
              </p>
              <div class="itemImg">
                <img v-if="$i18n.locale === 'zh-CN'" src="./image/1957.png" />
                <img v-if="$i18n.locale === 'en-US'" src="./image/2695-7.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterOther style="z-index: 66"></FooterOther>
  </div>
</template>
<script>
import Header from './../../../components/Header/BarOther.vue';
import FooterOther from './../../../components/Footer/FooterOther.vue';
export default {
  components: { Header, FooterOther },
  data() {
    return {
      data: {},

      dataUS: {
        setp1: {
          title: 'Sign up & Log in',
          list: [
            '1. If you are the first time visiting us, please click“Log in”and you will find the “sign up”button in another page.',
            'P.S : Currently for customers overseas, Phone verification is not avaliable. So please use E-mail to Sign up. ',
            '2. Then back to the “log in” TAB. Input your username and password to log in.',
          ],
        },
        setp2: {
          title: 'Create an order',
          list: [
            '1. Click “Instant Order” in the Menu on the left. Choose a service you want. ',
            '2. On the right side, you will find the service page. please fill in the information accordingly. e.g: Vendor info., Service date, Product spec., Requirement. ect. (Text boxes with “*”are required) ',
          ],
        },
        setp3: {
          title: 'Order confirmation & Get Quote',
          list: [
            '1. Click “Create the order”after all the text fields are filled and you can have a brief review of the order. click “OK” to confirm and your order will be created in the system.',
            '2. Our Staff will contact you to quote your order. (MD) ',
            '3. After that you can find your order in “My Order”-“Order List”. Click“Pay” to finish the payment.',
          ],
        },
        setp4: {
          title: 'Service',
          list: [
            '1. Our Inspection Engineer will contact the Factory/Vendor at once. All details such as location, due date, production status ect. will be double confirmed.',
            '2. The engineer will arrive at the assigned factory site to start the inspection. You can always get to know the inspection status simply by clicking“review”to check all details. ',
          ],
        },
        setp5: {
          title: 'Report audition & Release ',
          list: [
            '1. Our service team will create and audit the report after our engineer has finished the service. ',
            '2. You will be able to download the Final Report in “My Report”.',
            '3. Please evaluate and review the service in “My Review”.',
            '4. Feel free to contact our service team if you got any questions.',
          ],
        },
      },
      dataCN: {
        setp1: {
          title: '在线注册/登录',
          list: [
            '1. 新用户可在页面右上角 登录/注册 按钮中进行用户注册。',
            '2. 在登录界面使用已注册的用户名和密码进行账户登录',
          ],
        },
        setp2: {
          title: '填写并提交订单信息',
          list: [
            '1. 点击快速下单，选择对应服务项目。',
            '2. 在右边弹出的页面中跟据信息提示，完善公司/供应商信息，填写期望的服务时间地点，产品信息，检验要求等',
          ],
        },
        setp3: {
          title: '订单确认及报价',
          list: [
            '1. 在订单输入页面末端点击“提交订单”，并在弹出的页面中确认信息是否正确，确认无误后点击 “ok”生产订单 ',
            '2. 系统收到订单后，工作人员会主动联系客户确认订单所需的服务人天数。 ',
            '3. 确认后请在“我的订单”-“全部订单”中找到该订单并完成付款。',
          ],
        },
        setp4: {
          title: '执行检验任务',
          list: [
            '1. 曼德检验工程师在接到检验任务后会在第一时间与厂家取得联系，确认任务地点，时间，货品状态等信息。 ',
            '2. 检验任务当天，工程师会准时到达任务地点开始检验任务，检验过程中有任何情况均可随时通过订单列表中的“查看报告 ”功能来实时查看检验进度。',
          ],
        },
        setp5: {
          title: '报告验审及报告发布 ',
          list: [
            '1. 检验完成后，曼德将对检验工程师提交的报告进行细致的审核。 ',
            '2. 请通过订单列表中的查看报告功能收取/下载正式报告。 ',
            '3. 完成订单后请对该订单给予评价。 ',
            '4. 如有任何疑问，请联系客服人员。',
          ],
        },
      },
    };
  },
  created() {
    if (this.$i18n.locale === 'zh-CN') {
      this.data = this.dataCN;
    } else if (this.$i18n.locale === 'en-US') {
      this.data = this.dataUS;
    }
  },
  computed: {
    language: function () {
      return this.$i18n.locale;
    },
  },
  watch: {
    language: function () {
      if (this.$i18n.locale === 'zh-CN') {
        this.data = this.dataCN;
      } else if (this.$i18n.locale === 'en-US') {
        this.data = this.dataUS;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.top-bar {
  width: 100%;
  padding: 16px auto 16px 10%;

  text-align: left;
  background-color: #091d3e !important;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 30px;
}
.top-bar-f {
  height: 56px;
  line-height: 56px;
  margin: auto;
  font-weight: 300;
  font-size: 26px;
  color: #ffffff;
  font-style: normal;
}
.sticky {
  position: fixed;
  height: auto;
  z-index: 10000;
  background-color: #2778af;
  width: 100%;
  top: 0px;
  background-color: rgba(30, 30, 30, 0.94);
  border-bottom: none;
  padding: 0;
  -webkit-transition: all 2s ease-in-out;
  -moz-transition: all 2s ease-in-out;
  -ms-transition: all 2s ease-in-out;
  -o-transition: all 2s ease-in-out;
  transition: all 2s ease-in-out;
}
.silde-left {
  width: 340px;
  height: 550px;
  position: fixed;
  top: 190px;
  left: 0;
  z-index: 1;
}
.silde-right {
  width: 300px;
  height: 400px;
  position: fixed;
  opacity: 0.6;
  img {
    vertical-align: middle;
  }
  top: 700px;
  right: 0;
  z-index: 1;
}
.fastStart {
  width: 80%;
  margin: auto;
  .fast-con {
    text-align: left;
    margin: 20px 10%;
    .fastCon-Con {
      box-shadow: 0 0 10px 0px #999;
      padding: 50px 0;
      margin-bottom: 50px;
      .itemTitle {
        font-size: 20px;
        font-weight: 700;
        margin-left: 10%;
      }
      p {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 0;
        margin-left: 10%;
      }
      .itemImg {
        text-align: center;
        margin-top: 40px;
        img {
          max-width: 100%;
        }
      }
      .step1-US {
        display: flex;
        padding: 40px 10% 0;
        justify-content: space-around;
        > div {
          width: 40%;
          img {
            margin-bottom: 20px;
          }
          p {
            margin-left: 0;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
